<template>
  <div class="fill-height">
    <slot />
  </div>
</template>

<script>

export default {

};
</script>
